import React, { useState } from 'react';
import { Container, Form, Card } from 'react-bootstrap';
import { glossaryTerms } from '../glossaryData';

const GlossaryPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTerms = glossaryTerms.filter(
    (item) =>
      item.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.definition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Financial Glossary</h2>
      <Form.Group className="mb-4">
        <Form.Control
          type="text"
          placeholder="Search for a term..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form.Group>

      {filteredTerms.map((item, index) => (
        <Card key={index} className="mb-3">
          <Card.Body>
            <Card.Title>{item.term}</Card.Title>
            <Card.Text>{item.definition}</Card.Text>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
};

export default GlossaryPage;
